export default "__VITE_ASSET__DINuHX8d__"